// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../primitives/Json.res.js";
import * as OrderEdit from "./OrderEdit.res.js";
import * as Accounting from "@wino/accounting/src/Accounting.res.js";
import * as OrderStatus from "../../modules/Order/OrderStatus.res.js";
import * as Accounting__Serializer from "@wino/accounting/src/Accounting__Serializer.res.js";

function updateCartStocks(cart, stocks, statuses) {
  if (stocks === undefined) {
    return cart;
  }
  if (!OrderEdit.isBeforeReception(statuses)) {
    return cart;
  }
  let newrecord = {...cart};
  newrecord.products = cart.products.map(product => {
    if (product.TAG === "Unit") {
      let product$1 = product._0;
      let newrecord = {...product$1};
      let updatedStock = stocks.find(updatedStock => updatedStock.productId === product$1.id);
      newrecord.stock = updatedStock !== undefined ? updatedStock.rawQuantity : product$1.stock;
      return {
        TAG: "Unit",
        _0: newrecord
      };
    }
    let precision = product._1;
    let product$2 = product._0;
    let newrecord$1 = {...product$2};
    let updatedStock$1 = stocks.find(updatedStock => updatedStock.productId === product$2.id);
    newrecord$1.stock = updatedStock$1 !== undefined ? Accounting.fromRawProductQuantity(precision, updatedStock$1.rawQuantity) : product$2.stock;
    return {
      TAG: "Bulk",
      _0: newrecord$1,
      _1: precision
    };
  });
  return newrecord;
}

function serializeForm(param, state) {
  let serializedCart = Accounting__Serializer.serialize(state.cart);
  return Json.stringifyAny({
    condition: state.condition,
    noteForSupplier: state.noteForSupplier,
    supplierId: state.supplierId,
    issueDate: state.issueDate,
    estimatedReceptionDate: state.estimatedReceptionDate,
    note: state.note,
    cart: serializedCart
  });
}

function unserializeForm(extraData, serializedState) {
  let state = Json.parseExn(serializedState);
  let unserializedCart = Accounting__Serializer.deserialize(state.cart);
  let issueDate = new Date(state.issueDate);
  let estimatedReceptionDate = new Date(state.estimatedReceptionDate);
  let statuses = extraData.statuses;
  return {
    condition: state.condition,
    noteForSupplier: state.noteForSupplier,
    supplierId: state.supplierId,
    issueDate: issueDate,
    estimatedReceptionDate: estimatedReceptionDate,
    note: state.note,
    cart: OrderStatus.has(statuses, "DRAFT") ? unserializedCart : updateCartStocks(unserializedCart, extraData.stocks, statuses),
    shopId: extraData.shopId,
    deviceId: extraData.deviceId,
    supplierName: state.supplierName,
    supplierAddress: state.supplierAddress,
    supplierPostalCode: state.supplierPostalCode,
    supplierCity: state.supplierCity,
    supplierCountry: state.supplierCountry
  };
}

export {
  updateCartStocks,
  serializeForm,
  unserializeForm,
}
/* OrderEdit Not a pure module */
